import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { assetImages } from "../../../constants/assets";
import { darkColors } from "../../../theme/colors";
import { fontSizes } from "../../../theme/font-sizes";
import { formatTime } from "../format/time";
import GradientButton from "../gradient-button";

const ConfirmationModal = ({
  open,
  onClose,
  img,
  title,
  message,
  confirmButtonText,
  closeButtonText,
  handleSubmit,
  secondaryClick,
}) => {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          background: `linear-gradient(to bottom, ${darkColors.popupBgTop}, ${darkColors.popupBgBottom}`,
          borderRadius: "12px",
          maxWidth: "420px",
          width: "100%",
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          padding: 1,
          color: "white",
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" mt={8}>
          {img && (
            <Box
              component={"img"}
              src={img}
              alt="loading..."
              height={90}
              width={90}
            />
          )}

          <Typography
            fontWeight={700}
            fontSize={
              isMediumScreen ? fontSizes.heading2 : fontSizes.superHeading5
            }
            mt={4}
            textAlign={"center"}
            color="white"
          >
            {title}
          </Typography>

          <Typography
            mt={1}
            color="white"
            fontSize={fontSizes.heading3}
            textAlign={"center"}
          >
            {message}
          </Typography>
          <Box
            sx={{
              mt: 6,
              mb: 2,
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <GradientButton
              variant="contained"
              width="90%"
              onClick={handleSubmit}
              text={confirmButtonText}
              fontSize={fontSizes.heading2}
            />
          </Box>
          <Box
            sx={{
              mb: 2,
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              onClick={secondaryClick}
              style={{
                backgroundColor: "transparent",
                border: "none",
                color: darkColors.buttonTop,
                fontSize: isMediumScreen ? fontSizes.body : fontSizes.heading2,
                cursor: "pointer",
                fontWeight: 700,
              }}
            >
              {closeButtonText}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationModal;
